<template>
  <a-layout-content>
    <a-form layout="inline">
      <a-form-model-item>
        <a-select v-model="input.Aid" style="width: 250px" default-value="0" @change="query()">
          <a-select-option value="0">--- 全部活动 ---</a-select-option>
          <a-select-option v-for="item in selectOption.promotionslist" :key="item.ID">
            {{ item.ActiviesName }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-item label="会员账号">
        <a-input v-model="input.UserId" />
      </a-form-item>
      <a-form-item label="审核状态">
        <a-select v-model="input.State" style="width: 120px" @change="query()">
          <a-select-option value="0"> 全部</a-select-option>
          <a-select-option value="1"> 等待审核</a-select-option>
          <a-select-option value="2"> 审核通过</a-select-option>
          <a-select-option value="3"> 审核失败</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="时间范围">
        <a-range-picker :ranges="dataRange" :default-value="[moment().startOf('month'), moment().endOf('month')]"
          show-time :format="dateFormat" @change="onChange" />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="query()"><a-icon type="search" /></a-button>
      </a-form-item>
    </a-form>

    <div class="body-nest">
      <a-table bordered row-key="ID" size="small" :columns="columns" :data-source="datarow" :pagination="pagination"
        :row-selection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }" @change="changepage">
        <template slot="title">
          <a-row>
            <a-col style="float: right">
              <a href="javascript:;" @click="AllExport()">
                <a-icon type="file-excel" style="font-size: 22px"></a-icon>
                <span style="font-size: 15px">导出数据</span>
              </a>
            </a-col>
            <a-col :span="5" style="line-height: 30px; width: 280px">申请记录
              <span class="fontred">{{ clockNumer }}</span> 秒后刷新<a-button type="primary" @click="closeClock()">{{
                clockName }}</a-button>
            </a-col>
            <a-col :span="3" style="float: left">
              <a v-if="openaudio" @click="audiochange(0)"><img style="width: 30px; height: 30px;"
                  src="../../assets/svg/soundOn.svg"> </a>
              <a v-else @click="audiochange(1)"><img style="width: 30px; height: 30px;"
                  src="../../assets/svg/soundOff.svg"></a>
              新申请提示声
              <audio controls hidden ref="audio">
                <source src="../../assets/sound/msg2.mp3" />
              </audio>
            </a-col>
            <a-col style="float: left">
              <a-tag color="red">
                <a href="javascript:;" @click="BatchLockAPI(1)">
                  <a-icon type="lock" style="font-size: 22px"></a-icon>
                  <span style="font-size: 15px">批量锁定</span>
                </a></a-tag>
            </a-col>
            <a-col style="float: left">
              <a-tag color="red">
                <a href="javascript:;" @click="BatchLockAPI(2)">
                  <a-icon type="unlock" style="font-size: 22px"></a-icon>
                  <span style="font-size: 15px">批量解锁</span>
                </a></a-tag>
            </a-col>
            <a-col style="float: left">
              <a-tag color="red">
                <a href="javascript:;" @click="batchsetting(2, 0)">
                  <a-icon type="delete" style="font-size: 22px"></a-icon>
                  <span style="font-size: 15px">批量删除</span>
                </a></a-tag>
            </a-col>
            <a-col style="float: left">
              <a-tag color="blue">
                <a href="javascript:;" @click="batchsetting(1, 2)">
                  <a-icon type="check-circle" style="font-size: 22px"></a-icon>
                  <span style="font-size: 15px">批量审核通过</span>
                </a></a-tag>
            </a-col>
            <a-col style="float: left">
              <a-tag color="yellow">
                <a href="javascript:;" @click="batchsetting(1, 3)">
                  <a-icon type="close-circle" style="font-size: 22px"></a-icon>
                  <span style="font-size: 15px">批量审核不通过</span>
                </a>
              </a-tag>
            </a-col>
          </a-row>
        </template>
        <template slot="State" slot-scope="text, record">
          <a-tag v-if="record.State == '1'" color="gray">等待审核</a-tag>
          <a-tag v-else-if="record.State == '2'" color="cyan">审核通过</a-tag>
          <a-tag v-else-if="record.State == '3'" color="red">审核失败</a-tag>
        </template>
        <template slot="Operation" slot-scope="text, record">
          <a-tag color="green">
            <a href="javascript:;" @click="ShowStateModel(record)">
              <span style="font-size: 15px">审核操作</span>
            </a></a-tag>
          <template v-if="record.Locking === ''">
            <a-tooltip>
              <template slot="title"> 锁定 </template>
              <a-popconfirm title="确定要锁定?" @confirm="() => onLock(record)">
                <a href="javascript:;">
                  <a-icon type="lock" style="font-size: 22px"></a-icon>
                </a>
              </a-popconfirm>
            </a-tooltip>
            &nbsp;
          </template>
          <template v-else>
            <template v-if="record.Locking === CheckUserID">
              <a-tooltip>
                <template slot="title"> 解锁 </template>
                <a-popconfirm title="确定要解锁?" @confirm="() => onUnLock(record)">
                  <a href="javascript:;">
                    <a-icon type="unlock" style="font-size: 22px"></a-icon>
                  </a>
                </a-popconfirm>
              </a-tooltip>
              &nbsp;
            </template>
            <template v-else>
              <a-tooltip>
                <template slot="title"> 已锁定 </template>
                <a-icon type="lock" style="font-size: 22px; color: #52c41a"></a-icon>
              </a-tooltip>
              &nbsp;
            </template>
          </template>
          <a-tooltip title="删除">
            <a @click="deleteApply(record)">
              <a-icon type="delete" style="font-size: 18px"></a-icon>
            </a>
          </a-tooltip>
        </template>
      </a-table>
    </div>

    <!--------------------------------------------------弹窗部份-------------------------------------------------->
    <a-modal v-model="visible" row-key="ID" title="申请审核" width="40%" ok-text="提交" cancel-text="关闭" @ok="save()"
      layout="inline">
      <a-table bordered size="middle" :locale="{ emptyText: ' ' }" :columns="modelcolumns" :data-source="modeldata"
        :pagination="false">
      </a-table>
      <br />
      <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
        <a-form-item label="审核状态">
          <a-radio-group v-model="modelinput.State">
            <a-radio value="1">等待审核</a-radio>
            <a-radio value="2">审核通过</a-radio>
            <a-radio value="3">审核失败</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="备注">
          <a-textarea v-model="modelinput.Memo" :rows="4" allow-clear />
        </a-form-item>
      </a-form>
    </a-modal>
    <!--------------------------------------------------弹窗部份-------------------------------------------------->
  </a-layout-content>
</template>
<script>
  let datarow = [];
  let modeldata = [];
  import XLSX from "xlsx";
  import moment from "moment";
  import { jsonExportSheet } from "../../js/xlsxTool";
  import soundOff from '../../assets/svg/soundOff.svg';

  export default {
    data() {
      return {
        dataRange,
        visible: false,
        clockName: "停止刷新",
        clockNumer: 15,
        polling: undefined,
        CheckUserID: sessionStorage.UserID,
        //------table --------
        columns: IninTable(),
        datarow,
        pagination: {
          total: 0,
          pageindex: 1,
          pagesize: 10,
          showTotal: (total) => `共 ${total} 条`,
          showSizeChanger: true, // 可以改变每页个数
          pageSizeOptions: ["10", "20", "30", "50", "100", "500", "1000"],
          onShowSizeChange: (current, pageSize) => (this.pageSize = pageSize),
        },
        selectedRowKeys: [],
        //--------------------

        //------modeltable --------
        modelcolumns: modelIninTable(),
        modeldata,
        //--------------------
        input: {
          Aid: "0",
          UserId: "",
          State: "0",
          StarTime: "",
          EndTime: "",
        },
        modelinput: {
          ID: 0,
          State: "1",
          Memo: "",
        },
        selectOption: {
          promotionslist: [],
        },
        dateFormat: "YYYY-MM-DD HH:mm:ss",
        openaudio: false,
        maxid: 0,
        defaultid: 0,
      };
    },
    methods: {
      moment,
      query() {
        if (this.input.StarTime === "") {
          this.$message.warning("请选择查询开始时间!");
          return false;
        }
        if (this.input.EndTime === "") {
          this.$message.warning("请选择查询结束时间!");
          return false;
        }

        let params = {
          ID: parseInt(this.input.Aid),
          UserId: this.input.UserId,
          State: parseInt(this.input.State),
          Sdt: this.input.StarTime,
          Edt: this.input.EndTime,
          pageindex: this.pagination.pageindex,
          pagesize: this.pagination.pagesize,
        };

        this.axios
          .post("/promotions/getpromotionapplylist", params)
          .then((res) => {
            if (res.error == null) {
              this.datarow = res.data;
              this.pagination.total = res.total;
              this.maxid = res.uploadcount;
              this.audioapply();
            } else {
              this.$message.error(res.error);
            }
          });
      },
      //查询下拉活动
      qrydrpItem() {
        let params = {
          State: 1,
          pageindex: 1,
          pagesize: 9999999,
        };

        this.axios.post("/promotions/getpromotionlist", params).then((res) => {
          this.selectOption.promotionslist = res.data;
        });
      },
      //保存审核记录
      save() {
        let _this = this;
        let params = {
          ID: this.modelinput.ID,
          State: parseInt(this.modelinput.State),
          Memo: this.modelinput.Memo,
          Type: 2,
        };

        this.axios
          .post("/promotions/prommotionapplysetstate", params)
          .then((res) => {
            if (res.data) {
              _this.$message.success("保存成功!");
              this.visible = false;
              this.query();
            }
          });
      },
      deleteApply(record) {
        let _this = this;
        let params = {
          ID: record.ID,
          Type: 3,
        };
        this.$confirm({
          title: "删除数据",
          content: "您要确定要删除数据吗?",
          onOk() {
            _this.axios
              .post("/promotions/deleteprommotionapply", params)
              .then((res) => {
                if (res.data) {
                  _this.$message.success("删除成功");
                  _this.query();
                }
              });
          },
        });
      },
      //批量操作
      batchsetting(type, state) {
        if (this.selectedRowKeys.length < 1) {
          this.$message.warning("请勾选数据");
          return;
        }
        let url =
          type == 1
            ? "/promotions/batchcheckpromotionsapply"
            : "/promotions/batchdeletepromotionsapply";

        let that = this;
        this.$confirm({
          title: "批量操作",
          content: "您要确定要操作勾选数据吗?",
          onOk() {
            let IDList = [];
            that.selectedRowKeys.forEach((element) => {
              IDList.push({ ID: element });
            });
            that.axios
              .post(url, {
                IDList: IDList,
                State: state,
                Type: type,
              })
              .then((res) => {
                if (res.data) {
                  that.$message.success("操作成功");
                  that.query();
                }
              });
          },
        });
      },
      // 锁定
      onLock(data) {
        this.axios
          .post("/promotions/batchcheckpromotionsapply", {
            IDList: [{ ID: data.ID }],
            State: 1,
            Type: 3,
          })
          .then((res) => {
            if (res.data) {
              this.$message.success("锁定成功");
              this.query();
            }
          });
      },
      // 解锁
      onUnLock(data) {
        this.axios
          .post("/promotions/batchcheckpromotionsapply", {
            IDList: [{ ID: data.ID }],
            State: 2,
            Type: 3,
          })
          .then((res) => {
            if (res.data) {
              this.$message.success("解锁成功");
              this.qryListAPI();
            }
          });
      },
      // 解锁、锁定API
      BatchLockAPI(type) {
        if (this.selectedRowKeys.length < 1) {
          this.$message.warning("请勾选数据");
          return;
        }
        //1锁定 2解锁
        let msg = type === 1 ? "锁定" : "解锁";
        const that = this;
        this.$confirm({
          title: "订单" + msg,
          content: "您要确定要" + msg + "勾选数据吗?",
          onOk() {
            const idList = [];
            that.selectedRowKeys.forEach((element) => {
              idList.push({ ID: element });
            });
            that.axios
              .post("/promotions/batchcheckpromotionsapply", {
                IDList: idList,
                State: type,
                Type: 3,
              })
              .then((res) => {
                if (res.data) {
                  that.$message.success(msg + "成功");
                  that.query();
                }
              });
          },
        });
      },
      // 查询时间绑定
      onChange(value, dateString) {
        this.input.StarTime = dateString[0];
        this.input.EndTime = dateString[1];
      },
      //翻页
      changepage(e) {
        this.pagination.pageindex = e.current;
        this.pagination.pagesize = e.pageSize;
        this.query();
      },
      //批量选取
      onSelectChange(selectedRowKeys) {
        this.selectedRowKeys = selectedRowKeys;
      },
      ShowStateModel(record) {
        this.modelinput.State = record.State.toString();
        this.modelinput.Memo = record.Memo;
        this.modelinput.ID = record.ID;
        this.visible = true;
        this.modeldata = [];
        let params = {
          ID: record.Aid,
          Value: record.Value,
        };

        this.axios
          .post("/promotions/getpromotionapplyvalue", params)
          .then((res) => {
            this.modeldata = res.data;
            this.modeldata.unshift({ Name: "会员账号", Value: record.UserId });
          });
      },
      // 导出所有
      AllExport() {
        const _this = this;
        this.$confirm({
          title: "导出",
          content: "确定要导出筛选数据吗？",
          onOk() {
            _this.DataExport({
              ID: parseInt(_this.input.Aid),
              UserId: _this.input.UserId,
              State: parseInt(_this.input.State),
              Sdt: _this.input.StarTime,
              Edt: _this.input.EndTime,
              pageindex: 0,
              pagesize: 0,
            });
          },
        });
      },
      // 数据导出
      DataExport(data) {
        this.axios.post("/promotions/exportpromotionapply", data).then((res) => {
          if (res.data) {
            if (res.data.length > 0) {
              var sheet = XLSX.utils.json_to_sheet(res.data);
              sheet["A1"].v = "#";
              sheet["B1"].v = "申请时间";
              sheet["C1"].v = "活动名称";
              sheet["D1"].v = "会员账号";
              sheet["E1"].v = "IP";
              sheet["F1"].v = "审核状态";
              sheet["G1"].v = "备注";
              jsonExportSheet(sheet, this.moment().format("YYYYMMDDhhmmss"));
            } else {
              this.$message.warning("无数据导出!");
            }
          }
        });
      },
      //计时
      clockrepay() {
        const routes = this.$route.matched.concat().pop();
        if (routes.name === "activieapply") {
          if (this.clockNumer === 1) {
            this.query();
            this.clockNumer = 15;
          } else if (!this.loading) {
            this.clockNumer = this.clockNumer - 1;
          }
        }
      },
      closeClock() {
        if (this.clockNumer !== "--") {
          this.clockName = "启动刷新";
          this.polling = clearInterval(this.polling);
          this.clockNumer = "--";
        } else {
          this.clockName = "停止刷新";
          this.polling = self.setInterval(this.clockrepay, 1000);
          this.clockNumer = 15;
        }
      },
      audiochange(state) {
        this.openaudio = state == 1;
        this.defaultid = this.maxid;
      },
      audioapply() {
        if (this.openaudio) {
          if (this.maxid > this.defaultid) {
            this.$refs.audio.currentTime = 0;
            this.$refs.audio.play();
            this.defaultid = this.maxid;
          }
        }
      }
    },
    watch: {
      $route(to, from) {
        if (to.name === "activieapply") {
          this.input.State = "0";
          if (!stringIsNullorEmpty(this.$route.params.State)) {
            this.input.State = this.$route.params.State;
          }
          this.query();
        }
      },
    },
    created() {
      if (this.$route.name === "activieapply") {
        this.input.State = stringIsNullorEmpty(this.$route.params.State)
          ? "0"
          : this.$route.params.State;
      }
      // 初始化时间
      this.input.StarTime = moment().startOf("month").format(this.dateFormat);
      this.input.EndTime = moment().endOf("month").format(this.dateFormat);
      this.polling = self.setInterval(this.clockrepay, 1000); //获取权限
      this.query();
      this.qrydrpItem();
    },
  };

  let dataRange = {
    今天: [moment().startOf("day"), moment()],
    昨天: [
      moment().startOf("day").subtract(1, "days"),
      moment().startOf("day").subtract(1, "days"),
    ],
    本周: [moment().startOf("week"), moment().endOf("week")],
    本月: [moment().startOf("month"), moment().endOf("month")],
  };

  const IninTable = function IninTable() {
    var header = [];
    header.push({ title: "#", align: "center", dataIndex: "ID", width: 80 });
    header.push({
      title: "申请时间",
      align: "center",
      sorter: (a, b) =>
        new Date(a.Fdt.replace(/[\u4e00-\u9fa5]/g, "")).getTime() -
        new Date(b.Fdt.replace(/[\u4e00-\u9fa5]/g, "")).getTime(),
      dataIndex: "Fdt",
      width: 200,
    });
    header.push({
      title: "活动名称",
      align: "center",
      dataIndex: "ActiviesName",
    });
    header.push({
      title: "会员账号",
      align: "center",
      dataIndex: "UserId",
    });
    header.push({ title: "IP", align: "center", dataIndex: "IP", width: 100 });
    header.push({
      title: "审核状态",
      align: "center",
      scopedSlots: { customRender: "State" },
      dataIndex: "State",
      width: 100,
    });
    header.push({ title: "备注", align: "center", dataIndex: "Memo" });
    header.push({
      title: "最后修改时间",
      align: "center",
      sorter: (a, b) =>
        new Date(a.Ldt.replace(/[\u4e00-\u9fa5]/g, "")).getTime() -
        new Date(b.Ldt.replace(/[\u4e00-\u9fa5]/g, "")).getTime(),
      dataIndex: "Ldt",
      width: 200,
    });
    header.push({ title: "最后修改人", align: "center", dataIndex: "Editor" });
    header.push({
      title: "操作",
      align: "center",
      scopedSlots: { customRender: "Operation" },
      width: 200,
    });
    return header;
  };

  const modelIninTable = function modelIninTable() {
    var modelheader = [];
    modelheader.push({
      title: "字段名称",
      align: "center",
      dataIndex: "Name",
      width: 400,
    });
    modelheader.push({ title: "内容", align: "center", dataIndex: "Value" });
    return modelheader;
  };

  function stringIsNullorEmpty(value) {
    return !value || value == undefined || value == "" || value.length == 0;
  }
</script>

<style>
  .clearline {
    border-top: solid #acc0d8 1px;
    margin: 10px 0;
  }

  .soundOff {
    background-image: url("../../assets/svg/soundOff.svg");
    height: 100px;
    width: 100px;
  }

  .soundOn {
    background-image: url("../../assets/svg/soundOn.svg");
  }
</style>


// WEBPACK FOOTER //
// src/components/promotions/activieapply.vue